<template>
  <div
    class="ocp"
    :class="{ 'ocp--open': isOpen }"
  >
    <div
      role="presentation"
      class="ocp--backdrop"
      @click="onBackdropClick"
    />
    <div class="ocp--slide" :class="{ 'ocp--slide--full' : fullWidth }">
      <div
        v-loading="loading"
        class="ocp--content"
        :class="[...contentClasses, { 'ocp--content--full' : fullWidth }]"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { togglePageScroll } from '@/utils/general'

export default {
  name: 'Ocp',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    preventBackdropClose: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    contentClasses: {
      type: Array,
      default: () => ([])
    }
  },
  watch: {
    isOpen: {
      handler (newValue) {
        togglePageScroll(newValue)
      },
      immediate: true
    }
  },
  methods: {
    onBackdropClick () {
      if (!this.preventBackdropClose) {
        this.onClose()
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="postcss" scoped>
.ocp {
  @apply fixed left-0 h-full w-full;
  z-index: 100;
  top: -100%;
  --animation-duration: .4s;
  transition: top 0s var(--animation-duration);
}

.ocp--open {
  @apply top-0;
  transition: top 0s 0s;

  .ocp--backdrop {
    @apply opacity-25;
  }

  .ocp--slide {
    transform: translate3d(-100%, 0, 0);
  }
}

.ocp--backdrop {
  @apply absolute left-0 right-0 bottom-0 top-0 bg-black opacity-0 transition-opacity ease-in;
  transition-duration: var(--animation-duration);
}

.ocp--slide {
  @apply absolute top-0 max-w-full h-full transition-transform duration-500;
  left: 100%;
  transition-duration: var(--animation-duration);
  width: 36.5rem;
  transform: translate3d(0, 0, 0);

  &--full {
    @apply w-full;
  }
}

.ocp--content {
  @apply h-full rounded-l-md overflow-auto;

  &--full {
    @apply rounded-none !important;
  }
}

@screen lg {
  .ocp--slide {
    @apply pr-10 py-10;
    width: 58.2rem;

    &--full {
      @apply p-0;
      width: 40.8rem;
    }
  }

  .ocp--content {
    @apply rounded-r-md;
  }
}

>>> .loading-mask {
  @apply bg-transparent;
}
</style>
